import { Button, Dialog, DialogActions, DialogContent, TextField } from '@material-ui/core';
import { observer, useLocalStore } from 'mobx-react';
import * as React from 'react';
import { OcDataview } from '../../comps/OcDataview';
import { OcDataviewFiltering } from '../../comps/OcDataviewFiltering';
import { PleaseWait } from '../../comps/PleaseWait';
import { Submenu } from '../../comps/Submenu';
import { transl } from '../../main/transl';
import { useNoSubmenu } from '../../mainpanel/useSubmenu';
import { mgColumnFactory, MgColumnist } from '../../mg/table/MgColumn';
import { MgEntityEditDialog } from '../../mg/table/MgEntityEditDialog';
import { useStringStateAgg } from '../../mg/useStateAgg';
import { toasterSvc } from '../../services/ToasterSvc';
import { DataviewStore } from '../../stores/DataviewStore';
import { useOmnistore } from '../../stores/Omnistore';

const columnist = mgColumnFactory.createColumnist([
	'/id',
	'/creationTimestamp :datetime',
	'/timestamp :datetime',
	'/email',
	'firstname',
	'surname',
	'street',
	'number',
	'town',
	'zipcode',

	null,
	'isAdmin :bool',
	'isBlocked :bool',
	'isDeleted :bool',
	'isHarmonizer :bool',
	'phone',
	// 'language :enum', //TODO
	'wantsNewsEmail :bool',
	'wantsOrderOwnerEmail :bool',
	'wantsOrderInitiatorEmail :bool',
	'wantsOrderAttachment :bool',

	null,
	'/ohcVersion',
	'/failedLoginAttempts :nonNegInt',

	null,
	'/stat_lastOrderTimestamp :datetime',
	'/stat_previousMonthOrderCount :int',
	'/stat_currentMonthOrderCount :int',
	'/stat_orderCount :int',
	'/stat_prevalentDayOfWeek',
]);

const dataviewStore = DataviewStore.create({
	id: 'AdmUserPage',
	orgColumns: columnist.descriptors,
	filtering: [{columns: ['email'], value: ''}],
	sorting: {column: 'email'},
});
dataviewStore.addColumnHiderToNamed('DEFAULT', 'street', 'number', 'town', 'phone', 'imageLink',
	'isAdmin', 'isBlocked', 'isDeleted', 'isHarmonizer',
	'wantsNewsEmail', 'wantsOrderOwnerEmail', 'wantsOrderInitiatorEmail',
	'wantsOrderAttachment', 'failedLoginAttempts');

interface IAdmPaswordDialogProps {
	onDone(password: string) : void
}

const AdmPaswordDialog = observer(function AdmPaswordDialog(props: IAdmPaswordDialogProps) {
	const passwordAgg = useStringStateAgg('');
	const {onDone} = props;
	return <Dialog open={true}>
		<DialogContent>
			<TextField type="password" name="password" label="Admin Password" value={passwordAgg.value} onChange={passwordAgg.changeHandler}/>
		</DialogContent>
		<DialogActions>
			<Button onClick={() => onDone('')}>{transl('cancel')}</Button>
			<Button color="primary" onClick={() => onDone(passwordAgg.value)}>{transl('ok')}</Button>
		</DialogActions>
	</Dialog>;
});

interface IAdmUserDialogProps {
	columnist: MgColumnist
	entity?: any
	onClose() : void
}

const AdmUserDialog = observer(function AdmUserDialog(props: IAdmUserDialogProps) {
	const {columnist, entity, onClose} = props;
	const editable = useLocalStore(() => columnist.newEntity(entity)) as Record<string, string>;
	const actionAgg = useStringStateAgg('');
	const omnistore = useOmnistore();
	function finish(entity: Record<string, any>) : void {
		if (!entity) return onClose();
		omnistore.communicator.doPost('AdminUpdateUser', entity)
			.then(toasterSvc.handleResponse('saved'))
			.then(r => {
				if (r.outputObject) {
					omnistore.multirepo.admUserRepo.fetch('DIRECT');
					onClose();
				}
			});
	}
	function su(password: string) {
		omnistore.communicator.doPost('AdminSetUser', {adminPassword: password, sneaky: true, userId: entity.id})
			.then(toasterSvc.handleResponse('success'))
			.then(r => {
				if (r.outputList) {
					omnistore.authStore.setEmail(entity.email);
					omnistore.authStore.setRole('STANDARD');
					omnistore.locationStore.setPage('GDashboard');
					window.location.reload();
				}
			});
	}
	function setPassword(password: string) {
		omnistore.communicator.doPost('AdminSetPassword', {adminPassword: password, userId: entity.id})
			.then(toasterSvc.handleResponse('success'));
	}
	function action(password: string) {
		const action = actionAgg.value;
		actionAgg.setter('');
		if (!password) return;
		switch (action) {
		case 'su': return su(password);
		case 'setPassword': return setPassword(password);
		}
		throw new Error('No such action: ' + action);
	}
	return <>
		<MgEntityEditDialog
			columnist={columnist}
			extras={columnist.newExtras(editable, {})}
			entity={editable}
			baseName="AdmUserDialog"
			finish={finish}
		>
			{[
				{name: 'su', onClick: actionAgg.makeSetter('su')},
				{name: 'setPassword', onClick: actionAgg.makeSetter('setPassword')},
			]}
		</MgEntityEditDialog>
		{!actionAgg.value ? null : <AdmPaswordDialog onDone={action}/>}
	</>;
});

export const AdmUserPage = observer(function AdmUserPage() {
	const repo = useOmnistore().multirepo.admUserRepo;
	React.useEffect(() => {
		repo.fetch();
	}, []);
	useNoSubmenu();
	const onDialogClose = () => dataviewStore.rowClick(0);
	const selectedEntity = repo.byId(dataviewStore.selectedEntityId);
	return !repo.etag ? <PleaseWait/> : <>
		<Submenu>
			<OcDataviewFiltering state={dataviewStore} repo={repo}/>
			---
		</Submenu>
		<OcDataview state={dataviewStore} repo={repo}/>
		{!selectedEntity ? null : <AdmUserDialog entity={selectedEntity} columnist={columnist} onClose={onDialogClose}/>}
	</>;
});
